export const chartConstants = {
  CHART_GET_REQUEST: 'CHART_GET_REQUEST',
  CHART_GET_SUCCESS: 'CHART_GET_SUCCESS',
  CHART_GET_FAILURE: 'CHART_GET_FAILURE',

  CHART_TYPE: 'CHART_TYPE',
}
